import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Form,
  Spin,
  Col,
  Divider,
  Button,
  Modal,
  List,
  Tooltip,
  Tag,
  Badge,
  Table,
  Switch,
  Descriptions,
} from "antd";

import { LockOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import MainLayout from "../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import CustomButton from "../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const MakerChecker = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { state } = useLocation();

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.authorization}
        pageItems={staticConfig.authorizationBreadrumbItems}
      />

      <MakerCheckerWorkflow roleId={state} state={state} userData={userData} />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MakerChecker);

const MakerCheckerWorkflow = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userData } = props;
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);

  const [tasksData, setTasksData] = useState([]);
  const [rowTasksData, setRowTasksData] = useState([]);
  const [taskCodes, setPermissionCodes] = useState({});
  const [tasksObj, setTasksObj] = useState({});

  const columns = [
    {
      title: "Task Group Name",
      dataIndex: "displayGroupName",
    },
    Table.EXPAND_COLUMN,
    {
      title: "Total Tasks",
      dataIndex: "groupName",
      render: (record) => {
        const groupCount = rowTasksData.filter(
          (item) => item.grouping === record
        );
        let color = groupCount.length < 10 ? "geekblue" : "green";
        return <Tag color={color}>{groupCount.length}</Tag>;
      },
    },
  ];

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    const params = {
      makerCheckerable: "true",
    };

    const url = `${apiConfig.Permissions}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        const tempPermission = [];
        const tempPermissionCodes = {};
        setTasksObj(res);

        objList.forEach((element, index) => {
          tempPermission.push({
            key: index + 1,
            displayGroupName: formatName(element.grouping),
            groupName: element.grouping,
          });

          //   creation of one task and
          tempPermissionCodes[objList[index].code] = objList[index].selected;
        });

        // remove duplicate
        setTasksData(BOM.GetUnique(tempPermission, "groupName"));

        setRowTasksData(objList);

        //this will help us when saving
        setPermissionCodes(tempPermissionCodes);
        setIsLoading(false);
      }
    });
  };

  const formatName = (string) => {
    if (string.indexOf("portfolio_") > -1) {
      string = string.replace("portfolio_", "");
    }
    if (string.indexOf("transaction_") > -1) {
      var temp = string.split("_");
      string =
        temp[1] +
        " " +
        temp[0].charAt(0).toUpperCase() +
        temp[0].slice(1) +
        "s";
    }
    string = string.charAt(0).toUpperCase() + string.slice(1);
    return string;
  };

  const onSubmit = () => {
    const params = {
      makerCheckerable: "true",
    };

    const url = `${apiConfig.Permissions}`;

    let body = {
      session,
      method: "PUT",
      permissions: taskCodes,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Authorisation was successfully updated.");

          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <Card
      title={
        <div style={{ marginTop: 5 }}>
          <Badge color="var(--of-purple)" count={tasksData.length}>
            <span style={{ margin: 12 }}>{labelConfig.makerCheckerTasks}</span>
          </Badge>
        </div>
      }
      style={{
        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
        minHeight: 300,
        maxHeight: 540,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Spin spinning={isLoading} size="large">
        <Row gutter={[24, 0]}>
          <Col xs={24} lg={24}>
            <Table
              columns={columns}
              expandable={{
                expandedRowRender: (record) => {
                  let tempGroup = rowTasksData.filter(
                    (item) => item.grouping === record.groupName
                  );

                  const onSelectAll = (objParam) => {
                    rowTasksData
                      .filter((item) => item.grouping === objParam.groupName)
                      .forEach((element, index) => {
                        setPermissionCodes((prevState) => ({
                          ...prevState,
                          [element.code]: true,
                        }));
                      });

                    tempGroup.forEach((element) => {
                      element.selected = true;
                    });
                  };

                  const onDeselectAll = (objParam) => {
                    rowTasksData
                      .filter((item) => item.grouping === objParam.groupName)
                      .forEach((element, index) => {
                        setPermissionCodes((prevState) => ({
                          ...prevState,
                          [element.code]: false,
                        }));
                      });

                    tempGroup.forEach((element) => {
                      element.selected = false;
                    });
                  };

                  const onSelectPermission = (event, objParam) => {
                    /**
                     * UPDATE SPECIFIC PERMISSION
                     * event: is the switch value
                     */
                    const selectedObjIndex = tempGroup.findIndex(
                      (element) => element.code === objParam.code
                    );

                    switch (event) {
                      case true:
                        tempGroup[selectedObjIndex].selected = true;
                        setPermissionCodes({
                          ...taskCodes,
                          [objParam.code]: true,
                        });
                        break;

                      default:
                        tempGroup[selectedObjIndex].selected = false;
                        setPermissionCodes({
                          ...taskCodes,
                          [objParam.code]: false,
                        });
                        break;
                    }
                  };

                  return (
                    <>
                      <Divider orientation="right">
                        <Tooltip
                          placement="top"
                          title={`Select all tasks for ${record.groupName}`}
                        >
                          <Button
                            size="small"
                            shape="round"
                            className="of-primaryBtnColor"
                            onClick={() => onSelectAll(record)}
                            disabled={!BOM.HasPermission("UPDATE_PERMISSION")}
                          >
                            &nbsp; Select All
                          </Button>
                        </Tooltip>

                        <Tooltip
                          placement="top"
                          title={`Deselect all tasks for ${record.groupName}`}
                        >
                          <Button
                            size="small"
                            shape="round"
                            className="of-primaryBtnColor"
                            onClick={() => onDeselectAll(record)}
                            style={{ marginLeft: 10 }}
                            disabled={!BOM.HasPermission("UPDATE_PERMISSION")}
                          >
                            &nbsp; Deselect All
                          </Button>
                        </Tooltip>
                      </Divider>

                      <List
                        bordered
                        pagination={{ pageSize: 10, align: "center" }}
                        dataSource={tempGroup}
                        renderItem={(item, index) => (
                          <List.Item
                            key={index}
                            actions={[
                              <Switch
                                style={{ fontSize: 12 }}
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                checked={item.selected}
                                onClick={(e) => onSelectPermission(e, item)}
                                disabled={
                                  !BOM.HasPermission("UPDATE_PERMISSION")
                                }
                              />,
                            ]}
                          >
                            <List.Item.Meta
                              avatar={
                                <LockOutlined style={styles.iconSize12} />
                              }
                              title={
                                <div style={{ fontSize: 12 }}>
                                  &nbsp; {item.code}
                                </div>
                              }
                              description={
                                <div style={{ fontSize: 12 }}>
                                  {item.grouping} | {item.entityName}
                                </div>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    </>
                  );
                },
              }}
              dataSource={tasksData}
            />
          </Col>
        </Row>

        <Row>
          <Divider />
          <CustomButton
            content="Submit"
            style={{
              width: "10%",
              marginLeft: "auto",
              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            }}
            htmlType="submit"
            backgroundColor="#15CCAE"
            colorText="black"
            hoverBackground="#4FECA0"
            onClick={() => onSubmit()}
          />
        </Row>
      </Spin>
    </Card>
  );
};
